<template>
  <div class="firm_container">
    <div class="firm_Main_body">
      <!-- 头部导航栏 -->
      <div class="Navigation_con1">
        <div class="firm_placeholder"></div>
        <NavFirm :navNum="1" @handleWarn="handleWarn"></NavFirm>
      </div>
      <div class="firm-nav-table">
        <div class="Firm-nav">
          <leftMenu></leftMenu>
        </div>
        <div class="firm-center-body">
          <router-view></router-view>
          <!-- 账号注销提示弹窗 -->
          <SignOut
            :dialogSignOut="dialogSignOut"
            @handleClose="handleClose"
            @handleUnderstand="handleUnderstand"
          ></SignOut>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 账号注销提示弹窗
import SignOut from "../../personage/home/components/Popup/SignOut.vue";
// 反馈 客服
// import IndexRight from "../../../components/IndexRight.vue";
import NavFirm from "../../../components/NavFirm.vue";
import leftMenu from "./components/leftMenu.vue";
export default {
  props: {},
  // 局部注册的组件
  components: {
    NavFirm,
    leftMenu,
    // IndexRight,
    SignOut,
  },
  // 组件状态值
  data() {
    return {
      scroll: "",
      scrollType: "1",
      searchType: "",
      dialogSignOut: false, // 账号注销弹窗开启关闭
    };
  },
  watch: {
    scroll: {
      handler(newss, old) {
        if (newss > 80) {
          this.scrollType = "2";
        } else {
          this.scrollType = "1";
        }
      },
      immediate: false,
    },
  },
  // 组件初始化
  created() {
    var currentURL = window.location.href;
    console.log(currentURL);
  },
  // 组件实例挂载完毕
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  // 组件方法
  methods: {
    // 打开账号注销弹窗
    handleWarn() {
      this.dialogSignOut = true;
    },
    // 点击取消x 关闭账号注销提示弹窗
    handleClose() {
      this.dialogSignOut = !this.dialogSignOut;
    },
    // 账号注销弹窗 点击确认
    handleUnderstand() {
      this.dialogSignOut = !this.dialogSignOut;
      // 账号确认注销，关闭弹窗返回登录页
      this.$router.push("/login");
    },
    // 获取页面卷动高度
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/css/firmEachIndex.css";
</style>
